import React from 'react'
import { formatHour, TIMELINE_HOURS } from './timelineConstants'

export const TimelineHeader = () => (
  <div className="w-full flex items-center">
    <div className="w-56 shrink-0 h-11 px-3.5 py-3 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 flex items-center sticky left-0 z-10">
      <span className="text-gray-400 text-base font-medium font-['Inter']">Handwerkern</span>
    </div>
    <div className="flex-1 flex min-w-0">
      {TIMELINE_HOURS.map((hour: number) => (
        <div
          key={hour}
          className="flex-1 h-11 p-3 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 flex items-start overflow-hidden"
        >
          <span className="text-gray-400 text-base font-medium font-['Inter']">
            {formatHour(hour)}
          </span>
        </div>
      ))}
    </div>
  </div>
)
